import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const Slider3 = ({ data }) => {
  const [sliderHeight, setHight] = useState(" ");
  const [sliderMobileHeight, setMobileSliderHeight] = useState("200px");
  const [title, setTitle] = useState(" ");
  const [font, setFont] = useState("");
  const [titleAlignment, setTitleAlignment] = useState("");

  useEffect(() => {
    setHight(component.web_height || "200px");
    setTitle(component.title);
    setFont(component.web_title_font);
    setTitleAlignment(component.title_alignment);
  });

  const component = data;
  const sliders = data["get_home_component_details"]["content"];

  console.log("categories :- ", data);
  console.log("categories :- ", component.title);

  return (
    <div>
      <div className="text-2xl font-bold mb-0">{title}</div>

      <div className=" mx-auto py-10 " style={{ height: sliderHeight }}>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          className="w-full"
        >
          {sliders.map((slider) => (
            <SwiperSlide
              key={slider.component_auto_id}
              className="flex flex-col items-center bg-white  rounded-lg shadow-lg"
            >
              <img
                src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${slider.component_image}`}
                alt="Not Found"
                className=" w-full  object-cover"
                style={{
                  height:
                    window.innerWidth <= 768
                      ? sliderMobileHeight
                      : parseInt(sliderHeight, 10) + "px",
                 }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
